import { http } from './../../plugins/http/index';
import { getData } from "@/utils/get";

function fetchMoviesByCinemaId(cinemaId, cinemaProvider) {
    return http.get(`/integrations/schedule-cinemas/${cinemaProvider}/cinemas/${cinemaId}`).then(getData);
}

function fetchShowsByCinemaId(cinemaId) {
    return http.get(`nordic-cinema/shows/${cinemaId}`).then(getData);
}

export {
    fetchShowsByCinemaId,
    fetchMoviesByCinemaId
}